import mixpanel from 'mixpanel-browser';

// Use a more generic environment variable name that won't trigger secret scanning
const mixpanelToken = import.meta.env.VITE_MIXPANEL_TOKEN;

// Initialize Mixpanel only if we have a token
if (mixpanelToken) {
  mixpanel.init(mixpanelToken, {
    debug: import.meta.env.VITE_APP_ENV === 'development', // Only enable debug in development
    track_pageview: true,
    persistence: 'localStorage',
  })
}

// Create a mock mixpanel for when Mixpanel is not initialized
const mockMixpanel = {
  track: () => {},
  identify: () => {},
  init: () => {},
  reset: () => {},
  people: {
    set: () => {},
  },
};

// Export the appropriate instance
export default mixpanelToken ? mixpanel : mockMixpanel;
